<template>
    <div class="auth__completeregistration">
        <div class="auth__completeregistration_box">
            <div class="auth__completeregistration_box_title">Verify your account</div>
            <div class="auth__completeregistration_box_description">
                <component-text>You will shortly receive a verification email. Please click the link in the email to verify your account.</component-text>
                <component-text>Please check your spam folder if you do not find it in your inbox.</component-text>
            </div>
            <div class="auth__completeregistration_box_actions">
                <component-button
                    :align="'right'"
                    :name="'auth-complete-registration-actions-login'"
                    :theme="'default'"
                    :to="{ name: 'auth-login' }"
                >Back to login</component-button>
            </div>
        </div>
    </div>
</template>

<script>
import ComponentText from '@/components/default/shared/ComponentText'
import ComponentButton from '@/components/default/shared/ComponentButton'

export default {
  name: 'auth-complete-registration',
  components: { ComponentButton, ComponentText }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/auth/completeregistration/authcompleteregistration";
</style>
